export const _storeData = (key, value) => {
	return (dispatch) => {
		dispatch({ type: 'SET_PRODUCT_DATA', payload: { key: key, data: value } });
	};
};

export const storeProductData = (key, value) => async (dispatch) => {
	dispatch({ type: 'SET_PRODUCT_DATA', payload: { key: key, data: value } });
};
